import { CTA, CTAProps } from '@/components/CTA';
import React from 'react';

import classNames from 'classnames';
import styles from './RowHeader.module.scss';

export interface RowHeaderProps {
  title?: string;
  bodyText?: string;
  cta?: CTAProps;
  align?: 'start' | 'center';
}

export const RowHeader: React.FC<RowHeaderProps> = ({ title, bodyText, cta, align = 'start' }) => {
  return (
    <div
      className={classNames(
        styles.row_header_container,
        align == 'start' ? styles.align_start : styles.align_center,
      )}
    >
      <div className={styles.content}>
        {title && <div dangerouslySetInnerHTML={{ __html: title }} className={styles.title} />}
        {bodyText && (
          <div dangerouslySetInnerHTML={{ __html: bodyText }} className={styles.body_text} />
        )}
      </div>
      {cta && <CTA label={cta.label} link={cta.link} type={cta.type} />}
    </div>
  );
};
